import { useAuthStore } from "../state/auth";

export interface Hospital {
    id: string;
    name: string;
}

export async function fetchHospitals(): Promise<Hospital[]> {
    const { user, token } = useAuthStore.getState();
    if (!user?.email) throw new Error("User not authenticated");

    const headers: Record<string, string> = {
        "x-user-email": user.email,
    };
    if (token) {
        headers["Authorization"] = `Bearer ${token}`;
    }

    const response = await fetch("/api/hospitals", { headers });

    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || "Failed to fetch hospitals");
    }

    return response.json();
}
